import { render, staticRenderFns } from "./SavingsBySavingsType.vue?vue&type=template&id=623f1c22&scoped=true&"
import script from "./SavingsBySavingsType.vue?vue&type=script&lang=js&"
export * from "./SavingsBySavingsType.vue?vue&type=script&lang=js&"
import style0 from "./SavingsBySavingsType.vue?vue&type=style&index=0&id=623f1c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f1c22",
  null
  
)

export default component.exports